import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';

@Component({
  selector: 'kt-subs-confirmation',
  templateUrl: './subs-confirmation.component.html',
  styleUrls: ['./subs-confirmation.component.scss']
})
export class SubsConfirmationComponent implements OnInit {

  constructor(private activatedRoute: ActivatedRoute, private http: HttpClient, private cdr: ChangeDetectorRef) { }

  success = true;
  data;

  ngOnInit() {
	this.activatedRoute.queryParams.subscribe(params => {
        let url = params['url'];
		console.log(url); // Print the parameter to the console.
		this.getData(url);
    });
  }

  getData(url) {
	// const url = 'https://sns.us-west-2.amazonaws.com/?Action=ConfirmSubscription&TopicArn=arn:aws:sns:us-west-2:693556947396:post-log&Token=2336412f37fb687f5d51e6e2425ba1f25050711af8e7feac134697a00d200e4120768f864ef385a75928fc26ba5e3781050a0ead8647fc3aa6c3eca2106ca238c38123e76d7218a6a0785e42e0bfdc716d6a3a16cd2d3bede2f9735c0105531409155169a925f0b5c88adac52ef89913'; // Use 'http://' prefix for external URLs
	this.http.get(url).subscribe((data) => {
		this.data = data;
		this.success = true;
	  console.log('Received data:', data);
	  this.cdr.detectChanges();
	},error => {
		this.success = false;
		console.log({error});
		this.cdr.detectChanges();
	});
  }

}
